/**
 * Send cookies by default.
 *
 * By default, cookies aren't sent with fetch requests. We set the request to
 * send cookies by default.
 *
 * @param request The request to update.
 * @returns A duplicate request with the credentials set to "same-origin" if
 * they were "omit".
 */
export function sendCookies(request: Request): Request {
    if (request.credentials === "omit") {
        return new Request(request, {credentials: "same-origin"});
    }
    return request;
}
